(function ( $ ) {
    $.fn.signatureInput = function() {
        const input = $(this);
        if (input.hasClass('is-signature-input') || input.length === 0 || !input.is(':visible')) return;

        input.addClass('is-signature-input');

        const div = $('<div class="signature-canvas-inner" />');
        input.after(div);
        div.html(input);

        const $canvas = $('<canvas />');
        div.append($canvas);

        input.hide();

        const removeButton = $('<button><span class="visual-icon-trash"></span></button>');
        removeButton.css({
            position: 'absolute',
            right: '10px',
            bottom: '10px',
            transformOrigin: 'right bottom',
            transform: 'scale(1.5)',
        });
        div.append(removeButton);


        const canvas = $canvas[0];
        let context = canvas.getContext('2d');
        let rect = canvas.getBoundingClientRect();

        const updateValue = (value) => {
            // img.attr('src', value);
            input.val(value).trigger('change');
        }

        // Clear on button click
        removeButton.click(function() {
            updateValue('');
            context.clearRect(0, 0, canvas.width, canvas.height);
            return false;
        })

        // create a drawer which tracks touch movements
        const drawer = {
            isDrawing: false,
            pointerdown: function(coors){
                context.beginPath();
                context.moveTo(coors.x, coors.y);
                this.isDrawing = true;
                updateValue('');
            },
            pointermove: function(coors){
                if (this.isDrawing) {
                    context.lineTo(coors.x, coors.y);
                    context.lineWidth = 2;
                    context.stroke();
                }
            },
            pointerup: function(coors){
                if (this.isDrawing) {
                    this.pointermove(coors);
                    this.isDrawing = false;

                    let w = canvas.width, h = canvas.height,
                        pix = {x:[], y:[]},
                        imageData = context.getImageData(0, 0, canvas.width, canvas.height),
                        x, y, index;


                    const tempCanvas = document.createElement("canvas"),
                        tCtx = tempCanvas.getContext("2d");


                    for (y = 0; y < h; y++) {
                        for (x = 0; x < w; x++) {
                            index = (y * w + x) * 4;
                            if (imageData.data[index+3] > 0) {
                                pix.x.push(x);
                                pix.y.push(y);
                            }
                        }
                    }
                    pix.x.sort((a,b) => a-b);
                    pix.y.sort((a,b) => a-b);
                    const n = pix.x.length-1;

                    w = 1 + pix.x[n] - pix.x[0];
                    h = 1 + pix.y[n] - pix.y[0];
                    const cut = context.getImageData(pix.x[0], pix.y[0], w, h);

                    tempCanvas.width = w;
                    tempCanvas.height = h;
                    tCtx.putImageData(cut, 0, 0);

                    updateValue(tempCanvas.toDataURL('image/webp'));
                }
            }
        };
        const draw = (event) => {
            // get the touch coordinates
            const coors = {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top,
            };
            // pass the coordinates to the appropriate handler
            drawer[event.type](coors);
        }
        // attach the touchstart, touchmove, touchend event listeners.

        canvas.addEventListener('pointerdown',draw, false);
        canvas.addEventListener('pointermove',draw, false);
        canvas.addEventListener('pointerup',draw, false);

        const form = input.parents('form');
        if (form.length > 0) {
            const submitButton = form.find('[type="submit"]');
            if (submitButton.length > 0) {
                input.change(function() {
                    submitButton[0].disabled = input.val().length === 0;
                });
                input.trigger('change');
            }
        }

        const setSize = () => {
            rect = canvas.getBoundingClientRect();
            if (Math.round(rect.width) !== Math.round(canvas.width)) {
                canvas.width = Math.round(rect.width);
            }
            if (Math.round(rect.height) !== Math.round(canvas.height)) {
                canvas.height = Math.round(rect.height);
            }
        }
        canvas.addEventListener('pointerdown', setSize, false);

        return this;
    };
}( jQuery ));

jQuery(document).ready(function($) {
    const observer = new MutationObserver(function(mutations) {
        $('input[data-signature-input]').signatureInput();
    });
    observer.observe(document.querySelector('body'), { childList: true, attributes: false, subtree: true });
})
// jQuery(document).ready(function () {
//
//     sign_for_presence(307, 1377);
// })
